// extracted by mini-css-extract-plugin
export default {"autoComplete":"A3-z","error":"B3-z","disabled":"C3-z"};